angular.module('dpw.services')
    .factory('abstractLoginStatusHandlers', ['$rootScope', '$window', '$compile', 'api',
        function ($rootScope, $window, $compile, api) {
            return {
                'Success': loginSuccess,
                'Cancel_Trial': cancelTrial,
                'Disabled': popupAccountNotActive,
                'Failed': popupOtherErrors,
                'No_Permission': popupNoPermissionError,
                'Internal_Error': popupOtherErrors,
                'Trial_Expired': popupTrialExpired,
                'Unconfirmed': popupFreeAccountUnconfirmed
            };


            function appendInformForm(modal) {
                var $scope = $rootScope.$new();
                $scope.onInformed = function () {
                    modal && modal.footer(RCDPW.Lang.Login.KEEP_ME_INFORMED_SUCCESS);
                };
                var $informedForm = $compile('<div dpw-keep-me-informed></div>')($scope);
                return modal.footer(RCDPW.Lang.Login.KEEP_ME_INFORMED)
                    .$footerEl.append($informedForm);
            }

            function createOkHandler(data) {
                return function (modal) {
                    modal.close();
                    if (data.otherPage) {
                        api.threeLogout(function () {
                            $window.location.replace('login');
                        });
                    }
                };
            }

            function popupAccountNotActive(data) {
                var modal = RCDPW.modal.create()
                    .addClass('login-account-not-active')
                    .title(RCDPW.Lang.Login.ERROR_ACCOUNT_NOT_ACTIVE_TITLE)
                    .content(RCDPW.Lang.Login.ERROR_ACCOUNT_NOT_ACTIVE_CONTENT)
                    .ok(createOkHandler(data));

                appendInformForm(modal);
                modal.show();
            }

            function popupNoPermissionError(data) {
                var modal = RCDPW.modal.create()
                    .addClass('login-error-rejected')
                    .content(RCDPW.Lang.Login.ERROR_NO_PERMISSION)
                    .ok(createOkHandler(data));

                modal.show();
            }

            function popupTrialExpired(data) {
                var modal = RCDPW.modal.create()
                    .addClass('login-error-rejected')
                    .title(RCDPW.Lang.Login.ERROR_TRIAL_ACCOUNT_EXPIRED_TITLE)
                    .content(RCDPW.Lang.Login.ERROR_TRIAL_ACCOUNT_EXPIRED_CONTENT)
                    .ok(createOkHandler(data));

                appendInformForm(modal);
                modal.show();
            }

            function popupFreeAccountUnconfirmed(data) {
                var modal = RCDPW.modal.create()
                    .addClass('login-error-rejected')
                    .title(RCDPW.Lang.SORRY)
                    .content(RCDPW.Lang.Login.ERROR_FREE_ACCOUNT_NOT_ACTIVATED)
                    .ok(createOkHandler(data));

                modal.show();
            }

            function popupOtherErrors(data) {
                var modal = RCDPW.modal.create()
                    .addClass('login-error-rejected')
                    .title(RCDPW.Lang.Login.ERROR_REJECTED_TITLE)
                    .content(RCDPW.Lang.Login.ERROR_REJECTED_CONTENT)
                    .footer(RCDPW.Lang.Login.KEEP_ME_INFORMED)
                    .ok(createOkHandler(data));

                appendInformForm(modal);
                modal.show();
            }

            function loginSuccess() {
                //abstract method
            }

            function cancelTrial() {
                $window.location.replace(RCDPW.cancelTrailUrl);
            }
        }])
    .factory('loginService', ['$window', '$q', 'api', 'signUpDispatch', 'firstTimeLogin', 'abstractLoginStatusHandlers',
        'dpwStorage', 'myAccountUtils', 'mixpanelService', 'freeTierService', 'helpers', 'user', 'popupUtil',
        'organizationService', 'dpwUserRoleService',
        function ($window, $q, api, signUpDispatch, firstTimeLogin, abstractLoginStatusHandlers, dpwStorage, myAccountUtils,
                  mixpanelService, freeTierService, helpers, userService, popupUtil, organizationService, dpwUserRoleService) {
            'use strict';

            var loginStatusHandlers = _.assign({}, abstractLoginStatusHandlers, {Success: loginSuccess});

            return {
                postLogin: postLogin
            };


            function postLogin(data) {
                if (data.status.status !== 'SUCCESS') {
                    return popupInternalError(data);
                }

                var handler = loginStatusHandlers[data.loginStatus] || popupIsNotADeveloper;

                return handler(data);
            }

            function loginSuccess(options) {
                api.call(api.developerProvision(), function (sync) {
                    if (sync.user && sync.user.termsAccepted) {
                        myAccountUtils.getDevelopers({
                            onSuccess: function (data) {
                                termsAcceptedHandler(sync.user, data.developer, data.organization);
                            }
                        });
                    } else {
                        firstTimeLogin({
                            agree: postLoginRedirect,
                            user: sync.user
                        });
                    }
                });

                function termsAcceptedHandler(user, developer, organization) {
                    return $q.resolve()
                        .then(function () {
                            mixpanelService.identify(developer);
                        })
                        .then(function () {
                            return mixpanelService.setPeopleProperty({
                                '$distinct_id': developer.rcExtensionId,
                                'Org Type': organization.type,
                                'Org Link': helpers.getAdminSiteUrl('orgDetail', {
                                    orgId: organization.id
                                })
                            });
                        })
                        .then(function () {
                            return organizationService.getHashedAccountId().then(function (hashedAccountId) {
                                if (hashedAccountId) {
                                    return mixpanelService.set_group(hashedAccountId);
                                }
                            });
                        })
                        .then(function () {
                            return handleFreeAccount(user, developer, organization);
                        })
                        .then(function () {
                            postLoginRedirect(user);
                        });
                }

                function handleFreeAccount(user, developer, organization) {
                    if (isFreeAccountSystemExtensionFirstLogin(user, developer, organization)) {
                        return $q(function (resolve) {
                            popupUtil.ok({
                                title: ' ',
                                content: RCDPW.Lang.MyAccount.FREE_ACCOUNT_DISCLAIMER,
                                showCloseBtn: false,
                                callback: function () {
                                    mixpanelService.performTracking(mixpanelService.eventNames.DEV_FIRST_LOGIN, {
                                        'Org Type': organization.type
                                    }).then(function () {
                                        resolve();
                                    });
                                }
                            });
                        });
                    }
                }

                function isFreeAccountSystemExtensionFirstLogin(user, developer, organization) {
                    return (
                        freeTierService.isFreeAccount(user)
                        && developer.rcExtensionId === organization.rcAccountId
                        && user.isFirstLogin === true
                    );
                }

                function postLoginRedirect(user) {
                    // Login successfully, the local storage 'brandId' is set inside ngUser.js.
                    // On IE, when logging in through SSO, if use _.get(data, 'user.brand.id') to get the brandId,
                    //  the redirection is not working. The real cause is still unknown.

                    organizationService.isQuickStartFlowEnabled().then(function (quickStartFlowEnabled) {
                        if (quickStartFlowEnabled) {
                            var notAudit = user.role !== dpwUserRoleService.UserRole.Audit;
                            var defaultUrl = user.isFirstLogin && notAudit
                                ? RCDPW.helloWorldUrl + '?source=firstLogin'
                                : RCDPW.defaultPostLoginEntry.href;
                            redirectToDefault(defaultUrl);
                        } else {
                            redirectToDefault(RCDPW.defaultPostLoginEntry.href);
                        }
                    });

                    function redirectToDefault(defaultUrl) {
                        var redirectURL = dpwStorage.getItem("previousUrl") || defaultUrl;
                        $window.location.replace(redirectURL);
                    }
                }
            }

            function popupInternalError(data) {
                var modal = RCDPW.modal.create().content(RCDPW.Lang.INTERNAL_ERROR);
                if (data && data.otherPage) {
                    modal.ok(function () {
                        api.threeLogout(function () {
                            $window.location.replace('login');
                        });
                    });
                }

                modal.show();
            }

            function popupIsNotADeveloper(data) {
                signUpDispatch(data.loginStatus, {
                    onPartnerBrand: function () {
                        api.threeLogout(function () {
                            redirectToThankYou(data.brandId);
                        });
                    },
                    onTierNotSupported: function () {
                        api.threeLogout(function () {
                            redirectToThankYou(data.brandId);
                        });
                    },
                    onStandardTierMrr100: function () {
                        loginSuccess(data);
                    }
                });
            }

            function redirectToThankYou(brandId) {
                $window.location.replace('/thank-you-for-your-interest' + (brandId ? '?brandId=' + brandId : ''));
            }

        }]);

(function (appName) {

    RCDPW.Angular.setAppName(appName);

    RCDPW.Angular.buildModule('directives')
        .directive('loginForm', ['api', function (api) {
            return {
                restrict: 'A',
                scope: {
                    userInfo: '=',
                    submitButtonText: '@',
                    formType: '@',
                    popupIsNotADeveloper: '&',
                    ssoEntryPoint: '@'
                },
                bindToController: true,
                controllerAs: 'loginCtrl',
                templateUrl: 'login-form.html',
                controller: ['$scope', 'api', 'countries', 'defaultCountryId', 'loginService', 'dpwStorage',
                    LoginController]
            };
        }]);

    function LoginController($scope, api, countries, defaultCountryId, loginService, dpwStorage) {
        var self = this;
        self.countryList = countries;
        var countryId = +dpwStorage.getItem('countryId');
        self.country = _.find(countries, {id: countryId}) || _.find(countries, {id: defaultCountryId});
        self.forgetPasswordUrl = RCDPW.Lang.Login.FORGET_PASSWORD_URL;
        self.plansAndPricingUrl = RCDPW.Lang.Login.PLANS_AND_PRICING_URL;
        self.RCProductName = RCDPW.RCProductName;

        api.call(api.getNumber(), function (data) {
            if (data.phoneNumber) {
                self.userInfo.user = data.phoneNumber;
            }
            if (data.extension) {
                self.userInfo.extension = data.extension;
            }
        });

        self.submit = function () {
            var $form = $('.loginForm');
            if (!$form.valid()) {
                return;
            }
            self.userInfo.countryCode = self.country.code;
            api.call(api.signup.signup(self.userInfo), loginService.postLogin);
        };

        // Invoked by ssoCallback.js.
        RCDPW.ssoCallback = function (data) {
            // `this` is binded to the popup window.
            var ssoWindow = this;
            ssoWindow && ssoWindow.close();
            $scope.$apply(function () {
                loginService.postLogin(data);
            });
        };
    }
})(RCDPW.moduleNames.LOGIN);
